import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../../app-config.loader';
import { MyApplication } from '../layout.model';


@Injectable({
  providedIn: 'root'
})
export class MyApplicationsService {
  constructor(private httpClient: HttpClient, private appConfig: AppConfig) { }

  public get(): Observable<MyApplication[]> {
    let url = this.appConfig.settings.jwt.authenticationUrl;
    const index = url.indexOf('/authenticate/');
    if (index > -1) {
      url = url.substring(0, index);
    }

    return this.httpClient.get<MyApplication[]>(url + '/applications', { withCredentials: true });
  }
}
